import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

export const fetchNotifications = createAsyncThunk('notifications/fetch', async () => {
  const { data } = await axiosInstance.get('/notifications');
  return data.notifications || data;
});

export const markAsRead = createAsyncThunk('notifications/markAsRead', async (id) => {
  await axiosInstance.put(`/notifications/${id}/read`);
  return id;
});

export const markAllAsRead = createAsyncThunk('notifications/markAllAsRead', async () => {
  await axiosInstance.put('/notifications/mark-all-read');
  return true;
});

export const deleteAllRead = createAsyncThunk('notifications/deleteAllRead', async () => {
  await axiosInstance.delete('/notifications/delete-all-read');
  return true;
});

const initialState = {
  notifications: [],
  loading: false,
  error: null,
  settings: { email: true, push: true, inApp: true, budgetAlerts: true, goalReminders: true },
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => { state.notifications.unshift(action.payload); },
    removeNotification: (state, action) => { 
      state.notifications = state.notifications.filter(n => n.id !== action.payload); 
    },
    updateSettings: (state, action) => { 
      state.settings = { ...state.settings, ...action.payload }; 
    },
    clearAll: (state) => { state.notifications = []; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, action) => { 
        state.notifications = action.payload; 
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
        const notification = state.notifications.find(n => n.id === action.payload);
        if (notification) notification.is_read = true;
      })
      .addCase(markAllAsRead.fulfilled, (state) => {
        state.notifications.forEach(notification => {
          notification.is_read = true;
        });
      })
      .addCase(deleteAllRead.fulfilled, (state) => {
        state.notifications = state.notifications.filter(n => !n.is_read);
      });
  },
});

export const { addNotification, removeNotification, updateSettings, clearAll } = notificationSlice.actions;
export const selectNotifications = (state) => state.notifications.notifications;
export const selectUnreadCount = (state) => state.notifications.notifications.filter(n => !n.is_read).length;
export default notificationSlice.reducer; 